<template>
  <v-dialog width="500" v-model="info" style="backdrop-filter: blur(10px)">
    <template v-slot:default v-if="info">
      <v-card :color="info.color" rounded="0">
        <template v-slot:title>
          <p class="font-weight-bold text-center" style="text-align: center">{{ info.title }}</p>
        </template>
        <template v-slot:prepend>
          <v-avatar :color="info.color">
            <v-icon style="font-size: 25px" :icon="info.icon" />
          </v-avatar>
        </template>
        <template v-slot:append>
          <v-avatar :color="info.color">
            <v-icon style="font-size: 25px" :icon="info.icon" />
          </v-avatar>
        </template>
        <template v-slot:text>
          {{ info.text }}
        </template>
        <template v-slot:actions>
          <v-btn rounded="0" block variant="flat" color="white" v-on:click="info = null" text="ЗАКРЫТЬ" />
        </template>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import { Info } from "@/store/global/Allerts";

export default {
  name: "InfoComponent",
  data() {
    return {
      dialog: false
    }
  },
  computed: {
    info: {
      get() {
        return Info().get()
      },
      set(value) {
        Info().set(value)
      }
    }
  }
}
</script>

<style scoped>

</style>
